import { API } from '@/App';

/**
 * Resolve image URLs from backend uploads.
 * Old data uses /uploads/xxx, new data uses /api/uploads/xxx.
 * This function ensures both work through the Kubernetes ingress.
 */
export function resolveImageUrl(url) {
  if (!url || url.length < 5) return '';
  if (url.startsWith('http')) return url;
  const baseUrl = API.replace('/api', '');
  // Old paths: /uploads/xxx → /api/uploads/xxx
  if (url.startsWith('/uploads')) return `${baseUrl}/api${url}`;
  // New paths: /api/uploads/xxx or /api/cloud-files/xxx
  if (url.startsWith('/api/')) return `${baseUrl}${url}`;
  return url;
}
